var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z",
    fill: "#FEEBEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3705_14150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5068 17.2874C24.979 17.2874 26.0874 16.6837 26.9046 15.6326L25.8124 14.8123C25.5426 15.1623 25.1939 15.4458 24.7938 15.6406C24.3937 15.8353 23.9532 15.9359 23.5068 15.9345C21.909 15.9345 20.7513 14.6531 20.7513 13.0809C20.7513 11.5086 21.8902 10.1551 23.5524 10.1551C24.2913 10.1551 24.8135 10.3268 25.269 10.6046V11.9871H26.6435V9.97136L26.3802 9.76736C25.6246 9.18221 24.4707 8.87158 23.5063 8.87158C21.1485 8.87158 19.2307 10.7594 19.2307 13.0803C19.2307 15.3991 21.1479 17.2874 23.5068 17.2874ZM26.3585 25.589L26.3096 23.6514V18.9231H23.4429V20.2767H24.8618V23.4846C24.8618 24.8666 23.7896 25.8449 22.7079 25.8449C21.6263 25.8449 21.0618 25.1067 21.0618 23.7253V18.9226H18.384V20.2761H19.614V23.9599C19.614 25.8345 20.6818 27.1263 22.5863 27.1263C23.6807 27.1263 24.514 26.5285 25.0113 25.607H25.0335L25.2296 26.8955H27.4324V25.5906H26.3602V25.5879L26.3585 25.589ZM18.914 9.0701H16.5252L14.4474 15.0092H14.4152L12.3485 9.0701H9.80294V10.4242H11.2346L13.6985 17.1934H15.0074V17.1917L17.5768 10.4247H18.9129V9.07065L18.914 9.0701ZM7.56738 26.913H8.98294V25.5201H7.56794V26.913H7.56738ZM13.034 20.4927H13.0185L12.9296 18.9231H10.4029V20.1569H11.7474V25.5896H10.4029V26.8949H16.6474V25.6153H13.1707V22.3367C13.3279 21.15 14.2318 20.1367 15.4652 20.1367H15.4874L15.4624 21.3496H16.8368V18.9007H15.7502C14.5057 18.8974 13.5824 19.5603 13.0335 20.4932L13.034 20.4927Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3705_14150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "white",
    transform: "translate(7.5 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVc);
export default __webpack_public_path__ + "static/media/vc.99cbe39337cfc2a2b2c73b1a763b6e00.svg";
export { ForwardRef as ReactComponent };